import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { defer, Observable, of } from 'rxjs';
import { IsDeviceOnlineService } from '../services/is-online/is-online.service';
import { ResolveApiToResponseLocally } from '../utils/resolve-api-to-response';

@Injectable()
export class OfflinePwaInterceptor implements HttpInterceptor {
  constructor(private readonly _isDeviceOnlineService: IsDeviceOnlineService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (
      request.url === 'https://api64.ipify.org?format=json' ||
      request.url.startsWith('/assets/i18n')
    )
      return next.handle(request);

    switch (this._isDeviceOnlineService.currentNetwork) {
      case 'online': {
        return next.handle(request);
      }
      case 'offline': {
        const showActualContent = true;

        if (showActualContent) {
          return defer(async () => {
            const resolver = new ResolveApiToResponseLocally();
            const data = await resolver.resolve(request);
            return new HttpResponse({
              body: data
            });
          });
        } else {
          return defer(async () => new HttpResponse({ body: 'hi' }));
        }
      }
    }

    return next.handle(request);
  }

  private _isRequestNative(request: HttpRequest<unknown>) {
    return request.url.startsWith('https://dms.mycar-india.com');
  }
}
